import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import Calendar from '../shared/calendar/main';
import Filters from '../shared/filters/main';
import Table from '../shared/new-table/main';

import Form from './form/main';

import table from './table-initial-data';

import { selectors, actions } from './';

function Main({ intl, filters, calendar, data, updateById, removeById, ...props }) {
	return (
		<div className='priorities-page'>
			<div className='priorities-page-actions'>
				<div className='priorities-page-filters clearfix'>
					<Filters
						intl={intl} {...filters} filters={filters} // for crutch support
					/>
				</div>
				<Calendar
					intl={intl}
					{...calendar}
					onInit={calendar.calendarInit}
					onToggle={calendar.calendarToggle}
					onChange={calendar.calendarChange}
					onApply={calendar.calendarApply}
				/>
				<button
					className='ui-btn ui-btn-primary'
					onClick={props.apply}
				>
					{intl('Apply')}
				</button>
				<button
					className='ui-btn ui-btn-secondary ui-icon-clear'
					onClick={props.clear}
				/>
			</div>

			<Form />

			<div className='priorities-page-table-wrapper'>
				<Table
					payload={{ updateById, removeById }}
					table={table}
					rows={data || []}
				/>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		data: selectors.select(state, 'data'),
		// -----------------------------------------
		filters: selectors.getFilters(state),
		calendar: selectors.getCalendar(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		apply: () => dispatch(actions.apply()),
		clear: () => dispatch(actions.clear()),
		filters: bindActionCreators(actions.filters, dispatch),
		calendar: bindActionCreators(actions.calendar, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		filters: {
			...stateProps.filters,
			...dispatchProps.filters
		},
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
	withPageContainer(withIntl(Main), { name: 'Product Cap' })
);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/product-cap/main.js